<template>
<div>
  <v-container class="mt-5">
    <!-- head -->
    <v-row justify="space-between">
      <!-- title -->
      <v-col cols="6">
        <base-title no-margin-top>Users</base-title>
        <span class="primary--text text-caption">
          {{ totalUsers }} Users
        </span>
      </v-col>
      <!-- search field -->
      <v-col cols="3">
        <v-text-field
          dense
          rounded
          outlined
          prepend-inner-icon="mdi-magnify"
          placeholder="Search"
          hide-details
          @keyup="searchUsers($event)"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- user sorter -->
    <v-row align="center">
      <v-col>
        <!-- tab header -->
        <v-tabs
          height="40"
          v-model="tabItem"
          color="grey darken-2"
        >
          <v-tab class="text-none" active-class="font-weight-bold">All</v-tab>
          <v-tab class="text-none" active-class="font-weight-bold">Doctor</v-tab>
          <v-tab class="text-none" active-class="font-weight-bold">TMA</v-tab>
          <!-- <v-tab class="text-none" active-class="font-weight-bold">Patients</v-tab> -->
        </v-tabs>
      </v-col>
      <!-- <v-col>
        <v-select
          v-model="filter.sort.value"
          flat
          dense
          hide-details
          :items="filter.sort.options"
          @change="sortUsers($event)"
        ></v-select>
      </v-col> -->
      <v-spacer></v-spacer>
      <v-col class="d-flex">
        <router-link
          class="font-weight-medium primary--text ml-auto option-link text-subtitle-1"
          to="/users/add"
        >
          <v-icon
            small
            color="primary"
            class="pb-1"
          >
            mdi-plus
          </v-icon>
          Add User
        </router-link>
      </v-col>
    </v-row>

    <!-- user list -->
     <v-row align-content="start" class="overflow-y" style="height: 63vh;">
      <v-col
        v-for="(user, index) in users"
        :key="index"
        cols="3"
      >
        <user-card :user="user"></user-card>
      </v-col>
    </v-row>


  </v-container>
      <v-footer color="transparent">
      <div class="mx-auto py-5">
        <v-pagination
          v-model="page"
          :length="pages"
        ></v-pagination>
      </div>
    </v-footer>
  </div>
</template>

<script>
  import API from '@/api';
  const User = API.get('User');

  export default {
    name: "UserList",

    components: {
      UserCard: () => import('./UserCard.vue')
    },
    
    data() {
      return {
        tabItem: 0,
        page: 1,
        pages: 10,
        filter: {
          sort: {
            value: 'updated_at',
            options: [
              {
                text:'Sort by Date Modified',
                value:'updated_at'
              },
              {
                text:'Sort by Name',
                value:'email'
              }
            ]
          },
          search: ''
        },
        params: {
          page: 1,
          userType: 'tma_and_doctors_only',
          search: null
        },
        users: [],
        totalUsers: 0
      }
    },

    watch: {
      tabItem(value) {
        switch (value) {
          case 1:
            this.params = { page: 1, userType: 'doctors_only' }
            break;
          case 2:
            this.params = { page: 1, userType: 'tma_only' }
            break;
          case 3:
            this.params = { page: 1, userType: 'patients_only' }
            break;
          case 4:
            this.params = { page: 1, userType: 'admin_only' }
            break;
          default:
            this.params = { page: 1, userType: 'tma_and_doctors_only' }
            break;
        }
      },
      page(value) {
        this.params.page = value
      },
      params: {
        handler: function (value) {
          // setTimeout(() => {
            this.fetchUsers({ ...value })
          // }, 1000);
        },
        deep: true
      }
    },

    mounted() {
      this.fetchUsers({ ...this.params })
    },

    methods: {
      /** HELPERS */
      sortedUsers(val1, val2) {
        var sortProp = this.filter.sort.value
        return val1[sortProp].localeCompare(val2[sortProp])
      },
      async fetchUsers({ page = 1, search = '', perPage = 12, userType = 'tma_and_doctors_only', sortUpdateAt = 'ASC' }) {
        let params = {
          page,
          search,
          per_page: perPage,
          [userType]: true
        }

        if (sortUpdateAt) {
          params.sort_updated_at = sortUpdateAt
        }

        await User.fetch(params)
          .then(response => {
            this.users = response.data.data
            this.page = page
            this.pages = response.data.last_page
            this.totalUsers = response.data.total
          })
          .catch(error => {
            console.log({ error })
            this.totalUsers = 0
            this.users = []
          })
      },
      async searchUsers(event) {
        setTimeout(() => {
          this.params = {
            userType: this.params.userType,
            search: event.target.value,
            page: 1
          }
        }, 2000)
      },
      sortUsers(event) {
        console.log({ event })

        if (event === 'email') {
          this.users.sort(this.sortedUsers())
          return
        }

        if (event === 'updated_at') {
          this.params = {
            ...this.params,
            sortUpdateAt: 'sort_updated_at'
          }
          return
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.option-link {
  text-decoration: none;
}
</style>